import { render } from "./ActivityTemplate.vue?vue&type=template&id=5f21e8a6&scoped=true&ts=true"
import script from "./ActivityTemplate.vue?vue&type=script&lang=ts"
export * from "./ActivityTemplate.vue?vue&type=script&lang=ts"

import "./ActivityTemplate.vue?vue&type=style&index=0&id=5f21e8a6&lang=scss"
import "./ActivityTemplate.vue?vue&type=style&index=1&id=5f21e8a6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f21e8a6"]])

export default __exports__